import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import {
  nameFirme,
  statusName,
  kindName,
  reasonName,
  userName
} from "@/helpers/reference";

const state = {
  controlPacksFilter: {
    period: {
      enabled: false,
      dateBegin: "",
      dateEnd: ""
    },
    organization: {
      enabled: false,
      code: null
    },
    payment: {
      enabled: false,
      code: null
    },
    sum: {
      enabled: false,
      sumBegin: null,
      sumEnd: null
    },
    status: {
      enabled: false,
      code: null
    },
    operator: {
      enabled: false,
      code: null
    }
  },
  controlPacks: {
    data: []
  },
  statusPrepareChangeCheck: null,
  statusAfterQuestion: null,
  statusStornPack: null
};

const mutations = {
  setControlPacksFilter: (state, payload) =>
    (state.controlPacksFilter = payload),
  setControlPacks: (state, payload) => (state.controlPacks = payload),
  clearControlPacks: state => (state.controlPacks = { data: [] }),
  setStatusPrepareChangeCheck: (state, payload) =>
    (state.statusPrepareChangeCheck = payload),
  clearStatusPrepareChangeCheck: state =>
    (state.statusPrepareChangeCheck = null),
  setStatusAfterQuestion: (state, payload) =>
    (state.statusAfterQuestion = payload),
  clearStatusAfterQuestion: state => (state.statusAfterQuestion = null),
  setStatusStornPack: (state, payload) => (state.statusStornPack = payload),
  clearStatusStornPack: state => (state.statusStornPack = null)
};

const actions = {
  async getControlPacks({ commit, state, rootState }) {
    try {
      commit("setLoading", true);
      const filter = state.controlPacksFilter;
      let params = {
        script: "web.wbtpackpay",
        funcname: "wbRunSelect",
        dtBegin: `${filter.period.dateBegin}`,
        dtEnd: `${filter.period.dateEnd}`
      };
      if (filter.organization.enabled) {
        params["codefirme"] = filter.organization.code;
      }
      if (filter.payment.enabled) {
        params["kindpay"] = filter.payment.code;
      }
      if (filter.sum.enabled) {
        params["sumBegin"] = filter.sum.sumBegin;
        params["sumEnd"] = filter.sum.sumEnd;
      }
      if (filter.status.enabled) {
        params["status"] = filter.status.code;
      }
      if (filter.operator.enabled) {
        params["userid"] = filter.operator.code;
      }
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );
      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setControlPacks", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async prepareChangeCheck(
    { commit, rootState },
    { npack, kindpay, status, datebeginfact }
  ) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbpstornfromraznoska",
            funcname: "wbpreparechangecheck",
            npack: `${npack}`,
            status: `${status}`,
            kindpay: `${kindpay}`,
            datebeginfact: `${datebeginfact}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusPrepareChangeCheck", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async afterQuestion({ commit, rootState }, { npack, kindpay }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbpstornfromraznoska",
            funcname: "wbaftequestion",
            npack: `${npack}`,
            kindpay: `${kindpay}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusAfterQuestion", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async stornPackManual(
    { commit, rootState },
    { npack, codereason, datebeginfact }
  ) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbpstornfromraznoska",
            funcname: "wbstornpackmanual",
            npack: `${npack}`,
            codereason: `${codereason}`,
            datebeginfact: `${datebeginfact}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusStornPack", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async stornPack({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbpstornfromraznoska",
            funcname: "wbstornpack",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusStornPack", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  controlPacksFilter: state => state.controlPacksFilter,
  controlPacks: (state, rootState) => {
    let items = [];
    state.controlPacks.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["statusname"] = statusName(item.status);
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["reasonname"] = reasonName(
        rootState.params.codereason.data,
        item.codereason
      );
      item["username"] = userName(rootState.params.gusers.data, item.userid);
      item["paycodenamefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.paycodefirme
      );
      item["paykindname"] = kindName(
        rootState.params.gkindpay.data,
        item.paykindpay
      );
      items.push(item);
    });
    return items;
  },
  statusPrepareChangeCheck: state => state.statusPrepareChangeCheck,
  statusAfterQuestion: state => state.statusAfterQuestion,
  statusStornPack: state => state.statusStornPack
};

export default { state, mutations, actions, getters };
